import { MeetingEmployeePreparationQuery, MeetingEmployeePreparationQueryVariables } from '../../../types'
import { MEETING_EMPLOYEE_PREPARATION } from '../MeetingQueries'
import { ApolloError, useQuery } from '@apollo/client'

export const useMeetingEmployeePreparation = (
  meetingId: string,
): {
  data: MeetingEmployeePreparationQuery | undefined
  error: ApolloError | undefined
  loading: boolean
} => {
  const { data, error, loading } = useQuery<MeetingEmployeePreparationQuery, MeetingEmployeePreparationQueryVariables>(
    MEETING_EMPLOYEE_PREPARATION,
    {
      variables: {
        meetingId: meetingId,
      },
      fetchPolicy: 'network-only',
    },
  )

  return { data, error, loading }
}
